import React from "react";
import { useNavigate } from "react-router-dom";
import "../Event/AdminEvent.css";
import HeroSectionV2 from '../../../components/HeroSectionV2';
import Billede1 from '../../../Images/Billlede-1.png';

const TransportOverview: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div>
            <HeroSectionV2
                titleEn="Ticket"
                titleDa="Billetter"
                descriptionEn="Here you can create tickets and assign them"
                descriptionDa="Her kan du lave billetter og tildele dem"
                imageSrc={Billede1}
            />
        <div className="form-container">

            <h2>Transport Administration</h2>

            <div style={{ display: "flex", flexDirection: "column", gap: "12px", maxWidth: "300px" }}>
                <button
                    className="add-btn"
                    onClick={() => navigate("/FormTransportArrivalCreate")}
                >
                    ➕ Opret Transport Arrival
                </button>

                <button
                    className="add-btn"
                    onClick={() => navigate("/FormTransportDepartureCreate")}
                >
                    ➕ Opret Transport Departure
                </button>

                <button
                    className="add-btn"
                    onClick={() => navigate("/FormTransportLokalCreate")}
                >
                    ➕ Opret Transport Lokal
                </button>

                <hr />

                <button
                    className="add-btn"
                    onClick={() => navigate("/Transport_ArrivalListe")}
                >
                    📋 Se Transport Arrival Liste
                </button>
            </div>
            </div>
        </div>
    );
};

export default TransportOverview;
